import { navigate, useLocation } from '@reach/router';

import { useCallback } from 'react';

export const useQueryArg = (argName: string, scrollPos?: number) => {
    let location = useLocation();
    let argValue =
        typeof window !== 'undefined'
            ? new URL(location.href).searchParams.get(argName)
            : null;

    const setValue = useCallback(
        (value: string | undefined) => {
            let newLocation = new URL(location.href);
            if (value === '' || value === undefined)
                newLocation.searchParams.delete(argName);
            else newLocation.searchParams.set(argName, value);

            scrollPos
                ? navigate(newLocation.toString(), {
                      state: { scrollPosition: scrollPos },
                      replace: true,
                  })
                : navigate(newLocation.toString(), { replace: true });
        },
        [argName, location.href, scrollPos]
    );

    return [argValue, setValue] as const;
};
